<template>
  <div 
    v-if="(menu) && (menu.visible) && (menu.acessar !== 'recargaCreditosIABot' || podeRecarregarIA($store.getters.fgSistema, $store.getters.idEmitenteML))"
    class="menu-item" 
    :class="{
      'menu-accordion': ((menu.submenu) && (menu.submenu.length)), 
      'hover': defaultOpen, 
      'show': defaultOpen
    }" 
    :data-kt-menu-trigger="(((menu.submenu) && (menu.submenu.length)) ? 'click' : '')"
  >
    <a 
      v-if="!((menu.submenu) && (menu.submenu.length))" 
      class="menu-link" 
      :class="{'active': $route.name == menu.name}" 
      href="javascript:;" 
      @click="acessarMenu"
    >
      <span class="menu-icon" v-if="!bullet">
        <span class="svg-icon svg-icon-2">
          <slot name="icon"></slot>
        </span>
      </span>
      <span class="menu-bullet" v-if="bullet">
        <span class="bullet bullet-dot"></span>
      </span>
      <span v-if="!menu.bold" class="menu-title">
        {{ $t(menu.title) }}
      </span>
      <span v-if="menu.bold" class="menu-title">
        <b>{{ $t(menu.title) }}</b>
      </span>
    </a>
    <span class="menu-link" v-if="((menu.submenu) && (menu.submenu.length))">
      <span class="menu-icon" v-if="!bullet">
        <span class="svg-icon svg-icon-2">
          <slot name="icon"></slot>
        </span>
      </span>
      <span class="menu-bullet" v-if="bullet">
        <span class="bullet bullet-dot"></span>
      </span>
      <span v-if="!menu.bold" class="menu-title">
        {{ $t(menu.title) }}
      </span>
      <span v-if="menu.bold" class="menu-title">
        <b>{{ $t(menu.title) }}</b>
      </span>
      <span class="menu-arrow"></span>
    </span>
    <div 
      v-if="((menu.submenu) && (menu.submenu.length))" 
      class="menu-sub menu-sub-accordion" 
      :class="{'show': defaultOpen}"
    >
      <MenuItem v-for="submenu in menu.submenu" :key="submenu" :menu="submenu" :bullet="true" />
    </div>
    <div v-if="menu.separator" class="separator my-2" style="margin-left: calc(1.5rem + 10px);"></div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { podeRecarregarIA } from '../../../core/helpers/recargaCreditosIA';

export default {
  name: "MenuItem",
  props: ["menu", "bullet", "defaultOpen"], 
  methods: {
    podeRecarregarIA,
    ...mapActions(["registrarMenuFavorito"]), 
    async acessarMenu() {
      if(this.menu.acessar === 'recargaCreditosIABot' && !podeRecarregarIA(this.$store.getters.fgSistema, this.$store.getters.idEmitenteML)) return;
      if(this.menu.acessar) {
        await this.registrarMenuFavorito(this.menu.acessar);

        this.emitter.emit("atualizarMenuFavoritos", {});
        
        this.$router.push({
          name: this.menu.acessar
        });
      }
    }
  }
}
</script>
